import { Component, OnInit, ViewChild, AfterViewInit, Injector, OnDestroy } from '@angular/core';
import { NgbModal, NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ThemePalette, MatPaginator } from '@angular/material';
import { OrderService } from '../services/order-service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AppComponentBase } from '../../../../../../shared/app-component-base';
import { CustomLocalizationService } from '../../utility/customLocalization.service';
import { TestService } from 'test/service/test.service';
import { ApplicationError } from '@shared/services/appplication-error.model';


export interface Task {
	name: string;
	completed: boolean;
	color: ThemePalette;
	subtasks?: Task[];
}


@Component({
  selector: 'kt-claim-confirmation',
  templateUrl: './claim-confirmation.component.html',
  styleUrls: ['./claim-confirmation.component.scss']
})
export class ClaimConfirmationComponent extends AppComponentBase implements OnInit, OnDestroy {
	

	pendingRequestsAuthorization: boolean = false;
	isMyRequestAuth: boolean = false;

	tabIndex: number = 0;
	selectedIndex: number = 0;

	options: FormGroup;
	constructor(
		injector: Injector,
		private modalService: NgbModal,
		fb: FormBuilder,
		config: NgbPopoverConfig,
		private orderService: OrderService,
		private router: Router,
		private activeRoute: ActivatedRoute,
		private customLocalization: CustomLocalizationService,
		private _testService: TestService,

	) {

		super(injector);

		// customize default values of popovers used by this component tree
		config.placement = 'top';
		//config.triggers = 'hover';
		this.options = fb.group({
			'color': 'primary',
			'fontSize': [16, Validators.min(10)],
		});


	}

	ngOnInit() {

		this._testService.setTitle(this.customLocalization.l("FE.PAGEHEADERS.ORDER.ORDERAPPROVAL.HEADER"));
		this._testService.setDesc(this.customLocalization.l("FE.PAGEHEADERS.ORDER.ORDERAPPROVAL.SUBHEADER"));


		// //Url içerisinde değişim olduğu zaman yakalamak için kullanıyoruz.
		// //Diğer türlü url deki değişimi yakalayamıyoruz
		// this.router.events.subscribe((val) => {
		// 	console.log(val);
		// 	console.log("topbar içerisinden gel" + this.router.url);
		// 	var urlObj = this.router.url.split('/');
		// 	this.tabIndex = +(urlObj[urlObj.length - 1]);
		// 	this.selectedIndex = +(urlObj[urlObj.length - 1]);
		// });

		//Aktif olarak url bilgisini alıyoruz.
		this.activeRoute.paramMap.subscribe(res => {

			//Onayımı bekleyen talepleri görme yetkisi var mı onu buradan belirliyoruz.
			this.pendingRequestsAuthorization = this.appSession.user.isUserApprover;

			//Onay bekleyen talepler sayfası yetkisi var mı?
			this.isMyRequestAuth = this.appSession.user.isUserOrderer;

			//Burada yetki kontrolleri var mı diye bakıcaz.
			//Eğer yoksa yönledirip yetkn yok diyicez.

			if (!this.pendingRequestsAuthorization) {

				let tabIndex = +res.get("tabId");

				if (tabIndex == 1) {

					//ön taraftan kaynaklı hataları ile yakalar bir yapıya getirmeliyiz .
					this.errorHandler.setMessage(this.customLocalization.l("FE.PAGES.COMMON.NOTAUTH"));
					throw new ApplicationError();

				}

			} else if (!this.isMyRequestAuth) {

				let tabIndex = +res.get("tabId");

				if (tabIndex == 2) {

					//ön taraftan kaynaklı hataları ile yakalar bir yapıya getirmeliyiz .
					this.errorHandler.setMessage(this.customLocalization.l("FE.PAGES.COMMON.NOTAUTH"));
					throw new ApplicationError();

				}

			}

			



			//this.pendingRequestsAuthorization = true;
			//this.isMyRequestAuth = false;

			//Url içerisinde tab değerini yakalıyoruz
			//ve bu tab a ait componenti göster diyoruz.
			this.tabIndex = +res.get("tabId");

			//Hangi index seçili gelsin istiyorsak onu buraya belirtiyoruz.
			this.selectedIndex = +res.get("tabId");
			this.selectedIndex--;

			//Eğer onayımı bekleyen taleplerin yetkisi yok ise
			//diğer iki tab doğrı sekilde seçili gelmesi için 1 eksiğini alıyoruz
			//böylece doğru şekilde seçili geliyorlarç
			if (!this.pendingRequestsAuthorization) {

				this.selectedIndex--;
			}
			
		})
		
	}
	
	//ngAfterViewInit(): void {
		
	// this.activeRoute.paramMap.subscribe(res => {
	//	 console.log(res + "url parametreleri");

	//	 this.pendingRequestsAuthorization = this.appSession.user.isUserApprover;

	//	 this.tabIndex = +res.get("tabId");
	//	 this.selectedIndex = +res.get("tabId");
		 
	//	if (this.pendingRequestsAuthorization) {
	//		 (document.querySelector(".approveTabGroup .mat-tab-header .mat-tab-label-container .mat-tab-labels #mat-tab-label-0-0") as HTMLElement).style.display = 'inline-flex';

	//	}
	//	else{


	//		//(document.querySelector(".approveTabGroup .mat-tab-header .mat-tab-label-container .mat-tab-labels #mat-tab-label-0-0") as HTMLElement).style.display = 'none';
	//		 (document.querySelector(".approveTabGroup .mat-tab-header .mat-tab-label-container .mat-tab-labels .mat-tab-label-active") as HTMLElement).style.display = 'none';

	//		this.selectedIndex = 1;
	//	}

	//	})
	
	//}

	onTabChanged($event) {

		this.tabIndex = $event.index;

		this.tabIndex++;
		//bunun sebebi eğer yetkisi yok ise ilk tabindex ngIf ile dom eklenmediği için tabindex 0 dan başlıyacak
		//ancak o tabindex ait yer doğru olmaz
		//Mesela: tabindex: onayımı bekleyen taleplerim ise html tarafında
		//tabindex = 0 ise göster diyoruz
		// tabindex = 1 onay bekleyen,
		//tabindex = 2 ise geçmiş taleplerimdir
		//eğer yetkisi yok ise tabindex = 0 olmamalı çünki o tab DOM içerisine eklenmedi.
		//o yuzden yetki yok ise 1 fazlasını al diyoruz. çünki tabindex = 0 olmadığını biliyoruz
		//Çünki onInit içerisinde tabindex içerisine url de ki numarayı alıyoruz
		if (!this.pendingRequestsAuthorization) {
			this.tabIndex++;
		}


		//Eğer onayımı beklyen talepler sayfasına yetkisi olup, onay bekleyen talepler sayfasına yetkisi yok ise bu koşulaca gir diyoruz.
		if (this.pendingRequestsAuthorization && !this.isMyRequestAuth) {

			if ($event.index > 0) {
				this.tabIndex++;

			}

		}

		
		this.router.navigate(['../' + this.tabIndex], { relativeTo: this.activeRoute})

		console.log("TabChanged", $event);
	}


	ngOnDestroy(): void {
		this._testService.setTitle(" ");
		this._testService.setDesc(" ");
	}
}
